import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, FormsModule } from '@angular/forms';
import { NgbAlertModule, NgbDate, NgbDateParserFormatter, NgbDateStruct, NgbDatepickerModule, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateFormatter, DateFormatType } from './custom-date-formatter.service';

export class SelectedDates {
	startDate: NgbDate;
}

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [DatePipe, { provide: NgbDateParserFormatter, useClass: CustomDateFormatter }]
})

export class DatePickerComponent implements OnInit,OnChanges{
  model: NgbDateStruct;
  @Input() labelName:string;
  @Input() isRequired!:string;
  @Input() customClass!:string;
  @Output() selectedDate= new EventEmitter();
  @Input() dateFromParent:any;
  @Input() inputDate:string="";
  fromDate: NgbDate | null;
  @Input() fromDateFromParent;
  @Input() clearValue:boolean=false;
  // ********************************************
  @Input() disableFutureDate:boolean=false;
  @Input() disablePastDate:boolean=false;
  minDate: NgbDate;
  today: NgbDate;
  maxDate: NgbDate;

  @Input() showCalendarToggle:boolean=true;
  @Input() placeholder: string = 'MM-dd-yyyy';
  @Input() dateFormat: DateFormatType = 'MM-dd-yyyy';
  @ViewChild('d', { static: true }) datepicker: NgbDatepicker | undefined;

constructor(public formatter: NgbDateParserFormatter, private datePipe: DatePipe){}

private configureFormatter(): void {
  if (this.formatter instanceof CustomDateFormatter) {
    this.formatter.dateFormat = this.dateFormat;
  }
}

ngOnChanges(changes: SimpleChanges): void {
  this.configureFormatter();
  if(this.fromDateFromParent){
    this.assignToDatePicker()
  }
  if(changes['inputDate'] && this.inputDate){
    const parsedDate = this.formatter.parse(this.inputDate);
    if (parsedDate) {
      this.fromDate = new NgbDate(parsedDate.year, parsedDate.month, parsedDate.day);
    }
  }
}

ngOnInit(): void {
  this.configureFormatter();
   if (this.disableFutureDate) {
    this.futureDateDisable();
   }
    if (this.disablePastDate) {
    this.pastDateDisable();
   }
}

futureDateDisable(){
   const now = new Date();
    this.today = new NgbDate(
    now.getFullYear(),
    now.getMonth() + 1,
    now.getDate()
  );
    this.maxDate = this.today;
}

pastDateDisable() {
    const now = new Date();
    this.today = new NgbDate(
      now.getFullYear(),
      now.getMonth() + 1,
      now.getDate()
    );
    this.minDate = this.today;  
}

  assignToDatePicker(){
    if(this.fromDateFromParent){
      const parsedDate = this.formatter.parse(this.fromDateFromParent);
      if (parsedDate) {
        this.fromDate = new NgbDate(parsedDate.year, parsedDate.month, parsedDate.day);
        const formattedDate = this.formatter.format(this.fromDate);
        this.inputDate = formattedDate;
        this.selectedDate.emit(formattedDate);
      }
    } ;
  }

  onDateSelect(date: NgbDate) {
    this.fromDate=date;
    const formattedDate = this.formatter.format(this.fromDate);
    this.selectedDate.emit(formattedDate);
    this.inputDate  = formattedDate;
  }

  openCalendar() {
    if(this.fromDate){
      setTimeout(() => {
        if(this.datepicker && this.fromDate){
          this.datepicker.navigateTo(this.fromDate);
        }
      }, 100);
    }
  }
  clear(){
   this.inputDate = this.fromDateFromParent = '';
   this.fromDate = null;
   this.selectedDate.emit(this.inputDate);
  }
  allowOnlyDateChars(event: KeyboardEvent) {
  const allowed = this.dateFormat === 'dd/MM/yyyy' ? /[0-9/]/ : /[0-9-]/;
  if (!allowed.test(event.key)) {
    event.preventDefault();
  }
}
}
